const SCROLL_PADDING = 16;

const getDashboardScrollContainer = element =>
  element?.closest('[data-dashboard-grid-scroll]') ?? null;

export const scrollWidgetIntoView = widgetId => {
  if (!widgetId) return;

  const gridItem = document.querySelector(`[data-widget-id="${CSS.escape(widgetId)}"]`);
  if (!gridItem) return;

  const scrollContainer = getDashboardScrollContainer(gridItem);
  if (!scrollContainer) {
    gridItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    return;
  }

  const containerRect = scrollContainer.getBoundingClientRect();
  const targetRect = gridItem.getBoundingClientRect();

  const visibleTop = SCROLL_PADDING;
  const visibleBottom = containerRect.height - SCROLL_PADDING;
  const visibleHeight = visibleBottom - visibleTop;
  const targetHeight = targetRect.height;
  const targetTopInContainer = targetRect.top - containerRect.top + scrollContainer.scrollTop;

  let nextScrollTop;

  if (targetHeight <= visibleHeight) {
    nextScrollTop = targetTopInContainer - visibleTop - (visibleHeight - targetHeight) / 2;
  } else {
    nextScrollTop = targetTopInContainer - visibleTop;
  }

  const maxScroll = scrollContainer.scrollHeight - scrollContainer.clientHeight;
  nextScrollTop = Math.max(0, Math.min(nextScrollTop, maxScroll));

  scrollContainer.scrollTo({ top: nextScrollTop, behavior: 'smooth' });
};
